module.exports = __webpack_public_path__ + "static/img/zcfgBanner.41f78e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/icon/zcfgBanner.png
// module id = Hz9S
// module chunks = 1